import { User } from 'dashboard/models/user';
import { UserAuditLog } from 'dashboard/models/user-audit-log';
import {
  UserAuditLogActions,
  UserAuditLogActionType,
} from 'dashboard/redux/actions/user-audit-log';

export interface UserAuditLogState {
  userAuditLog: UserAuditLog | undefined;
  user: User | undefined;
}

const initialState: UserAuditLogState = {
  userAuditLog: undefined,
  user: undefined,
};

export default (state: UserAuditLogState = initialState, action: UserAuditLogActions) => {
  switch (action.type) {
    case UserAuditLogActionType.ClearUserAuditLog: {
      return initialState;
    }

    case UserAuditLogActionType.SetUserAuditLog: {
      return {
        ...state,
        userAuditLog: action.payload.userAuditLog,
        user: action.payload.user,
      };
    }

    default:
      return state;
  }
};
